import { Button, Input, Modal } from 'semantic-ui-react';
import styled from '@emotion/styled';

const LegadoCheckInContainer = styled.div`
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;

  .welcome-content {
    text-align: center;
    color: white;
    max-width: 600px;

    h1 {
      font-size: 3rem;
      margin-bottom: 1rem;
      font-weight: 700;
    }

    p {
      font-size: 1.2rem;
      margin-bottom: 2rem;
      opacity: 0.9;
    }
  }
`;

const LoginModalContainer = styled.div`
  .login-form {
    .form-group {
      margin-bottom: 20px;

      label {
        display: block;
        margin-bottom: 8px;
        font-weight: 500;
        color: #333;
      }

      .ui.input {
        width: 100%;

        &.error {
          input {
            border-color: #dc3545 !important;
          }
        }
      }
    }

    .error-message {
      color: #dc3545;
      font-size: 14px;
      margin-top: 5px;
    }

    .button-container {
      margin-top: 30px;
      display: flex;
      gap: 10px;
      justify-content: flex-end;
    }
  }
`;

const LegadoCheckIn = (props) => {
  const {
    inputs,
    setInputs,
    setModalOpen,
    setCategory,
    errorInputs,
    setErrorInputs,
    handleLogin,
    loading,
  } = props;

  const handleInputs = (event) => {
    const { name, value } = event.target;
    setInputs({ ...inputs, [name]: value });
    setErrorInputs((prev) => ({ ...prev, [name]: false }));
  };

  const handleCloseModal = () => {
    setModalOpen('');
    setErrorInputs({});
  };

  return (
    <LegadoCheckInContainer>
      <Modal open onClose={handleCloseModal} size="small" closeIcon>
        <Modal.Header>
          {inputs.comingFromDonation ? 'Ver tus donaciones' : 'Ir a donar'}
        </Modal.Header>
        <Modal.Content>
          <LoginModalContainer>
            <form
              id="legado-login-form"
              onSubmit={(e) => {
                e?.preventDefault?.();
                handleLogin();
              }}
              className="login-form"
            >
              <p style={{ marginBottom: '20px', color: '#666' }}>
                {inputs.comingFromDonation
                  ? 'Ingresa tu identificación y teléfono para acceder a tu información de donaciones'
                  : 'Ingresa tu identificación y teléfono para ir a donar y acceder a tu información de donaciones'}
              </p>

              {Object.values(errorInputs).includes(true) && (
                <div className="error-message" style={{ marginBottom: '15px' }}>
                  Por favor verifica los campos en rojo
                </div>
              )}

              <div className="form-group">
                <label htmlFor="identification">Identificación</label>
                <Input
                  id="identification"
                  name="identification"
                  type="number"
                  placeholder="Número de identificación"
                  value={inputs.identification}
                  onChange={handleInputs}
                  className={errorInputs.identification ? 'error' : ''}
                />
                {errorInputs.identification && (
                  <div className="error-message">
                    La identificación debe tener al menos 5 dígitos
                  </div>
                )}
              </div>

              <div className="form-group">
                <label htmlFor="phone">Teléfono</label>
                <Input
                  id="phone"
                  name="phone"
                  type="number"
                  placeholder="Número de teléfono"
                  value={inputs.phone}
                  onChange={handleInputs}
                  className={errorInputs.phone ? 'error' : ''}
                />
                {errorInputs.phone && (
                  <div className="error-message">El teléfono debe tener al menos 10 dígitos</div>
                )}
              </div>
            </form>
          </LoginModalContainer>
        </Modal.Content>
        <Modal.Actions>
          <div className="button-container">
            {inputs.comingFromDonation && (
              <Button
                onClick={() => {
                  setCategory('totalChurch');
                  handleCloseModal();
                }}
              >
                Ver avance total de la iglesia
              </Button>
            )}
            <Button
              primary
              type="submit"
              form="legado-login-form"
              loading={loading}
              disabled={loading}
            >
              Continuar
            </Button>
          </div>
        </Modal.Actions>
      </Modal>
    </LegadoCheckInContainer>
  );
};

export default LegadoCheckIn;
